import React from 'react';
import PropTypes from 'prop-types';

import TreatmentHeaderSection from '../../../components/TreatmentHeaderSection';
import TreatmentPageTabsSection from '../TreatmentPageTabsSection';

import formatDate from '../../helpers/dateFormat';

import './index.scss';

const TreatmentPageContent = ({ data, dispatch }) => {
  const { treatment, uiData } = data;
  const { header } = uiData;
  const activeStep = treatment.steps.find(
    (step) => step.id === treatment.activeStepId,
  );
  return (
    <>
      <TreatmentHeaderSection
        testCode={treatment.testCode}
        type={treatment.type}
        doctorName={header.doctorName}
        badge={{ text: activeStep.status }}
        status={activeStep?.status}
        title={header.title}
        imageUrlMobile={header.imageUrlMobile}
        imageAltMobile={header.imageAltMobile}
        imageUrlDesktop={header.imageUrlDesktop}
        imageAltDesktop={header.imageAltDesktop}
        avatarUrl={header.avatarUrl}
        avatarAlt={header.avatarAlt}
        doctorLabel={header.doctorLabel}
        startDateLabel={header.startDateLabel}
        startDateText={formatDate(header.startDate, false)}
        endDateLabel={header.endDateLabel}
        endDateText={formatDate(header.endDate, false)}
        className='treatment-page-content__header'
      />

      <TreatmentPageTabsSection data={data} dispatch={dispatch} />
    </>
  );
};

TreatmentPageContent.propTypes = {
  data: PropTypes.object,
  dispatch: PropTypes.func,
};

export default TreatmentPageContent;
